import { BaseWidgetComponent } from '@widgets/components/base-widget/base-widget.component';
import { Router } from '@angular/router';
import * as fromAnalyzeStore from '@appStore/analyze';
import * as fromAccountStore from '@appStore/account';
import { Store } from '@ngrx/store';
import { ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToLocalStringPipe } from '@utils/pipes';
import * as fromConfiguration from '@appStore/configuration';

type ComponentClass = new (
  router: Router,
  analyzeStore: Store<fromAnalyzeStore.State>,
  accountStore: Store<fromAccountStore.State>,
  changeDetectorRef: ChangeDetectorRef,
  translate: TranslateService,
  toLocal: ToLocalStringPipe,
  configStore: Store<fromConfiguration.State>
) => BaseWidgetComponent;

const WIDGET_REGISTRY = new Map<string, ComponentClass>();

export function WidgetTypeByName(name: string): ComponentClass {
  return WIDGET_REGISTRY.get(name);
}

export function RegisterWidget(cls: ComponentClass): void {
  const name = new cls(null, null, null, null, null, null, null).componentName;
  WIDGET_REGISTRY.set(name, cls);
}
